
import { useState } from 'react';
import { Editor } from '@tiptap/react';

export const useLinkDialog = (editor: Editor) => {
  const [isLinkDialogOpen, setIsLinkDialogOpen] = useState(false);
  const [linkUrl, setLinkUrl] = useState('');

  const openLinkDialog = () => {
    if (editor) {
      setIsLinkDialogOpen(true);
    }
  };

  const addLink = () => {
    if (linkUrl && editor) {
      // Vérifier si du texte est sélectionné
      const { from, to } = editor.state.selection;
      const isTextSelected = from !== to;

      if (!isTextSelected) {
        // Si aucun texte n'est sélectionné, insérer l'URL comme texte du lien
        editor.chain().focus()
          .insertContent(`<a href="${linkUrl}" target="_blank">${linkUrl}</a>`)
          .run();
      } else {
        // Si du texte est sélectionné, transformer ce texte en lien
        editor.chain().focus()
          .setLink({ href: linkUrl, target: '_blank' })
          .run();
      }

      setLinkUrl('');
      setIsLinkDialogOpen(false);
      console.log("Lien ajouté:", linkUrl);
    }
  };

  return {
    isLinkDialogOpen,
    setIsLinkDialogOpen,
    linkUrl,
    setLinkUrl,
    openLinkDialog,
    addLink
  };
};
